import React from "react";

/**
 * Composant React pour afficher un message lorsqu'aucun résultat n'est trouvé
 * @param {{title: string, message?: string, mode?: 'dark'|'light'}} props - Propriétés du composant
 * @returns {any} - Composant React
 */
function NoResult({ title, message, mode = 'dark' }) {
  const isLight = mode === 'light';

  return (
    <div className={`${ isLight ? 'background--light-grey' : 'background--dark-grey' } padding--32 flexline flexline--no-mobile flexline--direction-column flexline--gap-16 flexline--align-hz flexline--align-vz`} style={{ borderRadius: "8px" }}>
      <div className={isLight ? 'icon icon--circle' : 'icon icon--circle icon--grey-800'} style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", ...(isLight ? { backgroundColor: 'var(--grey-0)' } : {}) }}>
        <span className="icon__icon material-symbols-outlined" aria-hidden="true">
          search_off
        </span>
      </div>
      <p className={`paragraph paragraph--center ${ isLight ? 'paragraph--grey-900' : 'paragraph--grey-0' } paragraph--no-margin paragraph--bold-700 paragraph--h5`}>{title}</p>
      {message ? <p className={`paragraph paragraph--center ${ isLight ? 'paragraph--grey-600' : 'paragraph--grey-100' } paragraph--no-margin`}>{message}</p> : null}
    </div>
  );
}

export default NoResult;
